export default __webpack_public_path__ + "static/media/e.18bcb2bc.png";